import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import { format } from 'date-fns';

function Business() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [business, setBusiness] = useState([]);
    const [filteredBusiness, setFilteredBusiness] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    useEffect(() => {
        document.title = 'Infomart | Agent Business';
        fetchBusiness();
    }, []);
    const fetchBusiness = () => {
        setIsLoading(true);
        axios.get(`${BASE_URL}/agent/business`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setBusiness(res.data.data);
            setFilteredBusiness(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    };
    const handleFilter = () => {
        if (!fromDate || !toDate) {
            toast.warning('Select both from and to date.', { autoClose: 3000 });
            return;
        }
        const from = new Date(fromDate);
        const to = new Date(toDate);
        to.setHours(23, 59, 59, 999);
        const filtered = business.filter(item => {
            const createdAt = new Date(item.created_at);
            return createdAt >= from && createdAt <= to;
        });
        setFilteredBusiness(filtered);
    };
    const handleReset = () => {
        setFromDate('');
        setToDate('');
        setFilteredBusiness(business);
    };
    return (
        <div className="app">
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                        :
                        <div className="card">
                            <div className="card-header fw-bold d-flex justify-content-between align-items-center">
                                <span>Business</span>
                                <div className="d-flex flex-column flex-sm-row gap-2">
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fromDate || ""}
                                        onChange={(e) => setFromDate(e.target.value)}
                                    />
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={toDate || ""}
                                        onChange={(e) => setToDate(e.target.value)}
                                    />
                                    <button className="btn btn-sm btn-primary" onClick={handleFilter}>Filter</button>
                                    <button className="btn btn-sm btn-secondary" onClick={handleReset}>Reset</button>
                                </div>

                            </div>
                            {/* <div className="card-body" */}
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Client</th>
                                            <th scope="col">Listing</th>
                                            <th scope="col">Business (Amount)</th>
                                            <th scope="col">Amount (Commission)</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Date</th>
                                        </tr>
                                    </thead>
                                    <tbody className="align-middle">
                                        {filteredBusiness.length > 0 ? (
                                            filteredBusiness.map((data, i) => (
                                                <tr key={i}>
                                                    <th scope="row">{i + 1}</th>
                                                    <td>
                                                        <b>{data.vendor.name}</b>
                                                        <br />
                                                        +91 {data.vendor.phone}
                                                    </td>
                                                    <td>
                                                        <b>{data.listing.name}</b>
                                                        <br />
                                                        +91 {data.listing.phone}
                                                    </td>
                                                    <td>₹{data.business}.00</td>
                                                    <td>₹{data.amount}.00</td>
                                                    <td>
                                                        {data.status == 'Paid' ?
                                                            <span className="text-success fw-bold">{data.status}</span>
                                                            :
                                                            <span className="text-danger fw-bold">{data.status}</span>
                                                        }
                                                    </td>
                                                    <td>{format(data.created_at, 'dd MMM, yyyy')}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <th colSpan="6" className="text-center">No data available.</th>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default Business;             